import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE || '',
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
  },
});

// 요청마다 토큰 자동 주입
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});

// 401 수신 시 토큰 제거 후 로그인 페이지로
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('uam_user');
      window.location.href = '/';
    }
    return Promise.reject(err);
  }
);

export default api;
